(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class MarqueeBar extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.announcement-marquee__track');
      if (!this.track) return;

      this.baseGroups = Array.from(this.track.children);

      this.addEventListener('mouseenter', this.pause);
      this.addEventListener('mouseleave', this.play);
      this.addEventListener('focusin', this.pause);
      this.addEventListener('focusout', this.play);

      this.fillTrack();

      this.resizeObserver = new ResizeObserver(() => this.fillTrack());
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    // Duplicate the base set of items enough times that the track is always at
    // least one full set wider than the visible container. That guarantees the
    // seamless-loop math (shift left by exactly one set's width) never runs out
    // of content mid-scroll, regardless of how short the text is or how wide the
    // screen is.
    fillTrack() {
      if (!this.baseGroups || this.baseGroups.length === 0) return;

      Array.from(this.track.children).forEach((el) => {
        if (!this.baseGroups.includes(el)) el.remove();
      });

      const setWidth = this.baseGroups[0].getBoundingClientRect().width;
      if (setWidth === 0) return;

      const containerWidth = this.getBoundingClientRect().width;
      let guard = 0;
      while (this.track.scrollWidth < containerWidth + setWidth && guard < 20) {
        const clone = this.baseGroups[0].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        this.track.appendChild(clone);
        guard++;
      }

      this.track.style.setProperty('--marquee-set-width', `${setWidth}px`);
    }

    pause() {
      if (this.track) this.track.style.animationPlayState = 'paused';
    }

    play() {
      if (this.track) this.track.style.animationPlayState = 'running';
    }
  }

  if (!customElements.get('marquee-bar')) {
    customElements.define('marquee-bar', MarqueeBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('before-after-slider')) {
    customElements.define(
      'before-after-slider',
      class BeforeAfterSlider extends HTMLElement {
        connectedCallback() {
          this.dragging = false;
          this.onPointerDown = this.onPointerDown.bind(this);
          this.onPointerMove = this.onPointerMove.bind(this);
          this.onPointerUp = this.onPointerUp.bind(this);

          this.addEventListener('pointerdown', this.onPointerDown);
          this.addEventListener('pointermove', this.onPointerMove);
          this.addEventListener('pointerup', this.onPointerUp);
          this.addEventListener('pointerleave', this.onPointerUp);
        }

        setReveal(clientX) {
          const rect = this.getBoundingClientRect();
          const percent = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
          this.style.setProperty('--reveal', percent + '%');
        }

        onPointerDown(evt) {
          this.dragging = true;
          this.setPointerCapture(evt.pointerId);
          this.setReveal(evt.clientX);
        }

        onPointerMove(evt) {
          if (!this.dragging) return;
          this.setReveal(evt.clientX);
        }

        onPointerUp() {
          this.dragging = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
